
import React from 'react';
import videojs from 'video.js';

import { createPortal } from 'react-dom';
// This imports the functional component from the previous sample.
import VideoJS from './VideoJS'
const serverBaseURL = 'https://magic-dimensions.com:8443/'
const queryParameters = new URLSearchParams(window.location.search)
const clientURLFromQuery = queryParameters.get("id")
// if (typeof window !== 'undefined') { // Check if we're running in the browser.
// 	console.log('clientURLFromQuery',queryParameters.get('id'));
// }
//
const App =() => {
	const [videoData, setvideoData] = React.useState(null);
  const [showWhatsappModal, setShowWhatsappModal] = React.useState('False');
	const [logDBState, setLogDBState]  = React.useState(false);
  
  const cmArray = React.useRef(null)
  const cmClientInfo = React.useRef(null)
	const cmAccessedRef = React.useRef(null);
	const cmlastAccessedDateRef = React.useRef(null);
	const cmtimeLineRef = React.useRef(null);
	const cmawtRef = React.useRef(null);
	const cmwatchTimesRef = React.useRef(null);
	const cmClientProvidedPhoneRef = React.useRef(null);
	const interruptRef = React.useRef(null);

  const playerRef = React.useRef(null);
  const handlePlayerReady = (player) => {
    console.log('player',player);
       if(cmawtRef.current <1){
        console.log('cmawtRef', cmawtRef.current);
        setShowWhatsappModal('True');
      }
    playerRef.current = player;
    // You can handle player events here, for example:
    player.on('sourceset', () => {//gets set as soon as src is set
      console.log('sourceset');
      cmArray.current = [];
      cmAccessedRef.current = true;//check here **************>
      cmlastAccessedDateRef.current = new Date();//check here **************>
      //setShowWhatsappModal('False');
    });
    player.on('waiting', () => {//Player is waiting (A readyState change on the DOM element has caused playback to stop)
      videojs.log('player is waiting');
      console.log('waiting');	
    });
    player.on('dispose', () => {//Should do on window close; Test this 
      videojs.log('player will dispose');
    });
    player.on('ended' , () => {//player is in the ended state
      console.log('ended');
      console.log('cmawtRef',cmawtRef.current)
      cmArray.current.push({ timeStamp: new Date(), mode: 'ended', timeLine:player.currentTime() })
      setShowWhatsappModal('ended');
      setLogDBState(true);
      if(cmawtRef.current <1){
        console.log('cmawtRef', cmawtRef.current);
        setShowWhatsappModal('True');
      }
    });
    player.on('seeking' , () => {//When user plays with the seek bar
      cmArray.current.push({ timeStamp: new Date(), mode: 'seeking', timeLine:player.currentTime() })
      cmawtRef.current = cmawtRef.current - 1;//check here **************>
      cmwatchTimesRef.current = cmwatchTimesRef.current + 1;//check here **************>
      console.log('seeking');
      setShowWhatsappModal('seeking');
      console.log('cmawtRef',cmawtRef.current);
    });
    player.on('play' , () => {//video is playing
      setLogDBState(false);   
      cmArray.current.push({ timeStamp: new Date(), mode: 'play', timeLine:player.currentTime() })
      cmawtRef.current = cmawtRef.current - 1;//check here **************>
      cmwatchTimesRef.current = cmwatchTimesRef.current + 1;//check here **************>
      console.log('playing')
      console.log('cmawtRef',cmawtRef.current);
      setShowWhatsappModal('playing');
      setLogDBState(true);
    });
    player.on('pause' , () => {//video is paused
      cmArray.current.push({ timeStamp: new Date(), mode: 'pause', timeLine:player.currentTime() })
      //console.log('paused');
      cmtimeLineRef.current = player.currentTime();//check here **************>
      console.log('cmawtRef',cmawtRef.current);
      setShowWhatsappModal('paused');
    });
    player.on('error' , () => {//fires on error
      console.log('error');
    });
  };

  const videoJSOptions = React.useMemo(() => {
    return {
      autoplay: true,
      controls: true,
      responsive: true,
      fluid: true,
      controlBar: {
        progressControl: false
      },
      sources: [{
        src: videoData,
        type: "video/mp4"
      }]
    };
  }, [videoData]); //Empty array means "never recreate this object"

  interruptRef.current = document.querySelectorAll('.whatsapp-overlay-btn');

	console.log('React loop');

  React.useEffect(() => {
    async function getClientInfoFromServer(){
      try{
        const response = await fetch(serverBaseURL+'getVinfo?clientURL='+clientURLFromQuery);
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
        // console.log('response',response);
        const json = await response.text();
        // console.log('json',json);
        var vInfo = JSON.parse(json);
        // console.log('vInfo',vInfo);
        if (vInfo.found === true){
          setvideoData(vInfo.videoJSOptions.sources[0].src);
          cmClientInfo.current = vInfo.clientInfo;
          //console.log('cmclientInfo.current',cmclientInfo.current,'videoData',videoData);
          cmwatchTimesRef.current = 0;
          cmawtRef.current = vInfo.clientInfo.awt;
        }
        else{
          console.log('No client information found for client');
        }
      }
      catch (error) {
        console.error(error.message);
      }
    }
    //call the async function 
    getClientInfoFromServer();
    return () => {
      const url = "https://magic-dimensions.com:8443/logClick"; 
      const data = JSON.stringify({ message: 'return from useEffect! ' + cmClientInfo.current});

      // Send a background beacon request to the server
      navigator.sendBeacon(url, data);

    };
  },[] );
  React.useEffect(() => {
    if(videoData != null){
    console.log('logging cm');
    var jsonedData = JSON.stringify({
      clientID: cmClientInfo.current.clientID,
      clientURL: clientURLFromQuery,
      clientProvidedPhone: cmClientProvidedPhoneRef.current,
      accessed: true,
      lastAccessedDate: new Date(),
      awt: cmawtRef.current,
      renderedImages: [],
      metrics:{
        watchTimes: cmwatchTimesRef.current,
        //watchedTill:[{timeLine:cmtimeLineRef.current,timeStamp: new Date()}]//timeline & timestamp
        watchedTill:cmArray.current
      }
    })
    console.log('logging this in DB:',jsonedData)
    console.log('logging',cmArray.current);
    doSubmit(jsonedData);
    }
  }, [logDBState,videoData]);

  //Page closure handler 
  React.useEffect(() => {
    // 1. Regular React Cleanup (Runs when user switches pages/tabs inside your app)
    //const localTimer = setInterval(() => console.log('Running...'), 1000);
    const localTimer = setInterval(() => {}, 1000);

    // 2. Browser Closure Cleanup (Runs when the entire tab/window is closing)
    const handleTabClose = (event) => {
      // Perform fast, synchronous cleanup here
      console.log('User is closing the tab!');
      const url = "https://magic-dimensions.com:8443/logClick2"; 
      const data = JSON.stringify({ message: 'User closed the tab!' });
         // Send a background beacon request to the server
      navigator.sendBeacon(url, data);
    };

    window.addEventListener('beforeunload', handleTabClose);

    // The Return Function handles BOTH internal unmounting and external closing
    return () => {
      clearInterval(localTimer); // Cleans up local React tasks
      window.removeEventListener('beforeunload', handleTabClose); // Prevents memory leaks
    };
  }, []);


  if (videoData === null){
    return (
      <>
      <div 
      className="relative-container" 
      style={{ 
        position: 'relative', 
          display: 'inline-block', 
          width: '100%', 
      }}
      >
      {createPortal(
        <>
        <title>Anarorka</title>
        <meta property="og:title" content="Active Animation" />
        <meta property="og:image" content="https://res.cloudinary.com/dfcdhxaro/image/upload/v1782454802/longer1_pi7pob.gif" />
        </>,
        document.head
      )}

      <img 
      className="background-pic" 
      alt="Promotion Banner" 
      src="aegon-banner.png" 
      style={{ 
        width: '100%', 
          height: 'auto', 
          display: 'block' 
      }}
      />
      <a 
      className="whatsapp-overlay-btn"
      aria-label="Chat on WhatsApp" 
     // href="https://wa.me/919971359992" 
      href="https://magic-dimensions.com:8443/redirect?to=https://wa.me/919971359992"
      id="waTrack"
      ping="https://magic-dimensions.com:8443/logClick"
      target="_blank" 
      rel="noopener noreferrer"
      style={{ 
        position: 'absolute', 
          bottom: '20px', 
          right: '20px', 
          zIndex: 999,
          cursor: 'pointer'
      }}
      >
      <img alt="Chat on WhatsApp" src="/WhatsAppButtonGreenLarge.svg" />
      </a>
      </div>
      </>
    );
  }

  else if (videoData != null ){
  //else if(!playerRef.current){
    console.log('showWhatsappModal',showWhatsappModal);
    console.log('videoData',videoData,'playerRef.current',playerRef.current);
       
    return (
      <div> 
      {/* 1. Teleport the OG tags straight to the document <head> */}
      {createPortal(
        <>
        <title>Anarorka</title>
        <meta property="og:title" content="Active Animation" />
        <meta property="og:image" content="https://res.cloudinary.com/dfcdhxaro/image/upload/v1782454802/longer1_pi7pob.gif" />
        </>,
        document.head
      )}
      <VideoJS options={videoJSOptions} onReady={handlePlayerReady} />
      {/* 4. Display conditional HTML based on state */}
      <div>

      {showWhatsappModal === 'True' && (
        <div style={{
          position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)', // Semi-transparent black
            display: 'flex',
            justifyContent: 'center',             // Centers modal horizontally
            alignItems: 'center',                 // Centers modal vertically
            zIndex: 99999,                        // Guarantees it sits above all elements
            backdropFilter: 'blur(4px)'           // Slightly blurs background elements
        }}>

        <a 
        className="whatsapp-overlay-btn"
        aria-label="Chat on WhatsApp" 
        //href="https://wa.me/919971359992"
        href="https://magic-dimensions.com:8443/redirect?to=https://wa.me/919971359992"
        id="waTrack"
        ping="https://magic-dimensions.com:8443/logClick"
        target="_blank" 
        rel="noopener noreferrer"
        style={{ 
          display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#ffffff',        // Standard white card background
            padding: '30px', 
            borderRadius: '16px',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
            textDecoration: 'none',
            transition: 'transform 0.2s ease',
            cursor: 'pointer',
            maxWidth: '400px',
            width: '90%'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.03)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
        {/* WhatsApp Button Graphic */}
        <img 
        alt="Chat on WhatsApp" 
        src="/WhatsAppButtonGreenLarge.svg" 
        style={{ width: '100%', height: 'auto', maxWidth: '250px' }} 
        />

        {/* Optional helper text to encourage user clicks */}
        <p style={{ color: 'olivedrab', marginTop: '15px', fontFamily: 'sans-serif', fontWeight: 'bold' }}>
        You can get this on WhatsApp 
        </p>
        </a>
        </div>
      )}
      </div>
      </div>
    );
  }

  async function doSubmit(jsonedData){
    try{
      console.log('in doSubmit', jsonedData)
    await fetch(serverBaseURL+'submitClientMetric', {
      mode:  'cors' ,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: jsonedData,
    });
    }
    catch(error){
      console.log("error in funtion doSubmit",error.message)
      return (
      <div style={{ backgroundColor: 'black', color: 'red', height: '100vh', padding: '50px', textAlign: 'center' }}>
        <h1>CRITICAL APPLICATION ERROR</h1>
        <p>{error.message}</p>
        <p>The application has been terminated at this level.</p>
      </div>
    );
    }
  }
}



export default App;
